import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 198c-12.3 0-24.3-2.4-35.6-7.1-10.9-4.5-20.7-11.1-29.1-19.4-8.4-8.3-15-18-19.6-28.7-4.8-11.1-7.2-23-7.2-35.2 0-14.6 3.6-29.1 10.5-42 6.6-12.4 16.2-23.3 27.8-31.5 3.2-2.3 7.7-1.5 10 1.6 2.3 3.2 1.6 7.6-1.7 9.9-9.8 7-17.9 16.1-23.5 26.6-5.9 11-8.8 22.9-8.8 35.4 0 20.4 8 39.5 22.6 53.9 14.6 14.4 33.9 22.3 54.6 22.3 20.6 0 40-7.9 54.6-22.3 14.6-14.4 22.6-33.6 22.6-53.9 0-12.5-3-24.4-8.8-35.4a76.96 76.96 0 0 0-23.5-26.6c-3.2-2.3-4-6.7-1.7-9.9s6.8-3.9 10-1.6c11.6 8.2 21.2 19.1 27.8 31.5 6.9 12.8 10.5 27.4 10.5 42 0 12.2-2.4 24.1-7.2 35.2-4.6 10.8-11.2 20.4-19.6 28.7-8.4 8.3-18.2 14.8-29.1 19.4A92.32 92.32 0 0 1 100 198zm2.1-98.1c-4 0-7.2-3.2-7.2-7.1V9.1c0-3.9 3.2-7.1 7.2-7.1s7.2 3.2 7.2 7.1v83.7c0 3.9-3.2 7.1-7.2 7.1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}